import React from 'react';
import Title from '../../atoms/title/title.js';

const MarketingBanner = ({ offers, offerIcon }) => {
    const renderTitle = (offer) => {
        let wrapperClassName = "mbw-marketing-banner-item-wrapper";
        if (offers.length === 1) {
            wrapperClassName += " mbw-marketing-banner-wraper-single-item";
        }
        return (React.createElement("div", { className: wrapperClassName },
            React.createElement("div", { className: "mbw-marketing-banner-title" },
                React.createElement(Title, { fontStyle: "heading-h4" }, offer.title),
                React.createElement(Title, { fontStyle: "content-small" }, offer.subtitle))));
    };
    const contentHolderClass = "mbw-marketing-banner-content-holder";
    return (React.createElement("div", { className: "mbw-marketing-banner-wrapper" },
        React.createElement("div", { className: contentHolderClass },
            renderTitle(offers[0]),
            React.createElement("div", { className: "mbw-marketing-banner-icon" }, offerIcon),
            offers[1] && renderTitle(offers[1]))));
};

export { MarketingBanner as default };
//# sourceMappingURL=marketing_banner.js.map
